/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CabinClassType,
    CabinClassTypeFromJSON,
    CabinClassTypeFromJSONTyped,
    CabinClassTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface CabinClassTypeCriteriaInput
 */
export interface CabinClassTypeCriteriaInput {
    /**
     * 
     * @type {boolean}
     * @memberof CabinClassTypeCriteriaInput
     */
    exclude?: boolean;
    /**
     * 
     * @type {CabinClassType}
     * @memberof CabinClassTypeCriteriaInput
     */
    value?: CabinClassType;
}

export function CabinClassTypeCriteriaInputFromJSON(json: any): CabinClassTypeCriteriaInput {
    return CabinClassTypeCriteriaInputFromJSONTyped(json, false);
}

export function CabinClassTypeCriteriaInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): CabinClassTypeCriteriaInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
        'value': !exists(json, 'value') ? undefined : CabinClassTypeFromJSON(json['value']),
    };
}

export function CabinClassTypeCriteriaInputToJSON(value?: CabinClassTypeCriteriaInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'exclude': value.exclude,
        'value': CabinClassTypeToJSON(value.value),
    };
}


